import loadMonetateModule from './modules/Monetate.module';
import loadCookieConsentModule from './modules/CookieConsent.module';
import loadBasketModule from './modules/Basket.module';
import loadWishListModule from './modules/WishList.module';
import loadCompareModule from './modules/Compare.module';
import loadDeliveryPromiseModule from './modules/DeliveryPromise.module';
const loadProductGroupMonetateModule = () => ({
    hasRouter: false,
    modules: [
        loadMonetateModule(),
        loadCookieConsentModule(),
        loadBasketModule(),
        loadCompareModule(),
        loadWishListModule(),
        loadDeliveryPromiseModule(),
    ],
});
export default loadProductGroupMonetateModule;
